import React, { Component } from 'react';
import Login from './components/Login';
import AboutUS from './components/AboutUS';
import Dashboard from './components/Dashboard';
import ChatBot from './components/ChatBot';
import Register from './components/Register';
import Approve from './components/Approve';
import Pending from './components/Pending';
import ProtocolMaster from './components/ProtocolMaster';
import AdverseEffectsMaster from './components/AdverseEffectsMaster';
import MedicineMaster from './components/MedicineMaster';
import LabTestParameterMaster from './components/LabTestParameterMaster';
import ReportParamMappingMST from './components/ReportParamMappingMst';
import AddReportParameter from './components/AddReportParameter';
import AddProtocol from './components/AddProtocol';
import AddMedicine from './components/AddMedicine';
import AddLabTestParameter from './components/AddLabTestParameter';
import AddAdverseEffects from './components/AddAdverseEffects';
import ViewProtocol from './components/ViewProtocol';
import Case from './components/Case';
import ApproveCase from './components/ApproveCase';
import PatientProfile from './components/CaseProfile';
import Doctor from './components/Doctor';
import Appointments from './components/appointmentsView';
import ConsentMale from './components/ConsentFormMale';
import ConsentFemale from './components/ConsentFormFemale';
import ChemoTemplate from './components/ChemoTemplate';
import ChemoTemplateForNurse from './components/ChemoTemplateForNurse';
import ChemoTemplateForPatient from './components/ChemoTemplateForPatient';
import ChemoTemplateForPharmacist from './components/ChemoTemplateForPharmacist';

import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import ForgotPassword from './components/ForgotPassword';
import Analytics from './components/Analytics';
import ChemoPlanReport from './components/ChemoPlanReport';
import ChemoEntry from './components/ChemoEntry';
import ChemoAppointment from './components/ChemoAppointment';
import PlanCompletion from './components/PlanCompletion';
import AnalyticsReport from './components/AnalyticsReport';
import ProgressionReport from './components/ProgressionReport';
import ChemoPatientDashboard from './components/ChemoPatientDashboard';
import ChemoTemplateToAOC from './components/ChemoTemplateToAOC';
//import DischargeSummary from './components/DischargeSummary';
import CurrentDischargeSummary from './components/CurrentDischargeSummary';

// Add new imports for Invoice components
import Invoice from './components/Invoice';
import AddInvoice from './components/AddInvoice';
import EditInvoice from './components/EditInvoice';
import ViewInvoice from './components/ViewInvoice';
import MedicalHistory from './components/MedicalHistory';

// Import DayCare components
import DayCare from './components/DayCare';
import AddDayCarePatient from './components/AddDayCarePatient';

// Import TumorBoard component
import TumorBoard from './components/TumorBoard';

class App extends Component {
  render() {
    return (
      <div className='App'>
        <Router>
          <Switch>
            <Route path='/sign-in'>
              <Login />
            </Route>
            <Route path='/register'>
              <Register />
            </Route>
            <Route path='/forgotPassword'>
              <ForgotPassword />
            </Route>
            <Route path='/dashboard'>
              <Dashboard />
            </Route>
            <Route path='/approve'>
              <Approve />
            </Route>
            <Route path='/pending'>
              <Pending />
            </Route>
            <Route path='/AddProtocol' render={props => <AddProtocol {...props} />}>
            </Route>
            <Route path='/ReportParamMappingMST' render={props => <ReportParamMappingMST {...props} />}>
            </Route>
            <Route path='/AddReportParameter' render={props => <AddReportParameter {...props} />}>
            </Route>
            <Route path='/AddLabTestParameter' render={props => <AddLabTestParameter {...props} />}>
            </Route>
            <Route path='/AddMedicine' render={props => <AddMedicine {...props} />}>
            </Route>
            <Route path='/AddAdverseEffects' render={props => <AddAdverseEffects {...props} />}>
            </Route>
            <Route path='/ViewProtocol' render={props => <ViewProtocol {...props} />}>
            </Route>
            <Route path='/ProtocolMaster' render={props => <ProtocolMaster {...props} />}>
            </Route>
            <Route path='/AdverseEffectsMaster'>
              <AdverseEffectsMaster />
            </Route>
            <Route path='/MedicineMaster'>
              <MedicineMaster />
            </Route>
            <Route path='/LabTestParameterMaster'>
              <LabTestParameterMaster />
            </Route>
            <Route path='/case'>
              <Case />
            </Route>
            <Route path='/Analytics'>
              <Analytics element={<Analytics/>}/>                       
            </Route>
            <Route path='/AnalyticsReport'>
              <AnalyticsReport/>                       
            </Route>
            <Route path='/chemoPlan'>
              <ChemoPlanReport />
            </Route>
            <Route path='/chemoEntry'>
              <ChemoEntry />
            </Route>
            <Route path='/chemoAppointment'>
              <ChemoAppointment />
            </Route>
            <Route path='/ProgressionReport'>
              <ProgressionReport />
            </Route>
            <Route path='/planCompletion'>
              <PlanCompletion />
            </Route>
            <Route path='/ChemoPatientDashboard'>
              <ChemoPatientDashboard/>
            </Route>
            {/* Invoice routes */}
            <Route path='/Invoices'>
              <Invoice />
            </Route>
            <Route path='/AddInvoice' render={props => <AddInvoice {...props} />}>
            </Route>
            <Route path='/editInvoice/:invoiceNumber' render={props => <EditInvoice {...props} />}>
            </Route>
            <Route path="/viewInvoice/:invoiceNumber" component={ViewInvoice} />
            <Route path='/ConsentFormMale' render={props => <ConsentMale {...props} />}>
            </Route>
            <Route path='/ConsentFormFemale' render={props => <ConsentFemale {...props} />}>
            </Route>
            <Route path='/approvecase' render={props => <ApproveCase {...props} />}>
            </Route>
            <Route path='/caseprofile' render={props => <PatientProfile {...props} />}>
            </Route>

            <Route path='/medicalHistory' render={props => {
              // Extract patientId from URL query parameters
              const searchParams = new URLSearchParams(props.location.search);
              const patientId = searchParams.get('patientId');
              return <MedicalHistory {...props} patientId={patientId} isEditMode={true} />;
            }}>
            </Route>
            <Route path='/medical-history' render={props => {
              // Extract patientId from URL query parameters
              const searchParams = new URLSearchParams(props.location.search);
              const patientId = searchParams.get('patientId');
              return <MedicalHistory {...props} patientId={patientId} isEditMode={true} />;
            }}>
            </Route>
            <Route path='/view-medical-history' render={props => {
              // Extract patientId from URL query parameters
              const searchParams = new URLSearchParams(props.location.search);
              const patientId = searchParams.get('patientId');
              return <MedicalHistory {...props} patientId={patientId} isEditMode={false} />;
            }}></Route>

            <Route path='/ChemoTemplate' render={props => <ChemoTemplate {...props} />}>
            </Route>
            <Route path='/ChemoTemplateForNurse' render={props => <ChemoTemplateForNurse {...props} />}>
            </Route>
            <Route path='/ChemoTemplateForPatient' render={props => <ChemoTemplateForPatient {...props} />}>
            </Route>
            <Route path='/ChemoTemplateForPharmacist' render={props => <ChemoTemplateForPharmacist {...props} />}>
            </Route>
            <Route path='/ChemoTemplateToAOC' render={props => <ChemoTemplateToAOC {...props} />}>
            </Route>
            {/* <Route path='/DischargeSummary' render={props => <CurrentDischargeSummary {...props} />}>
            </Route> */}
            <Route path='/CurrentDischargeSummary' render={props => <CurrentDischargeSummary {...props} />}>
            </Route>
            <Route path='/doctor'>
              <Doctor />
            </Route>
            <Route path='/appointmentView'>
              <Appointments />
            </Route>
            <Route path='/AboutUS'>
              <AboutUS />
            </Route>
            <Route path='/'>
              <Login />
            </Route>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;